import { useState } from "react";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import { SquareCheck, Filter } from "lucide-react";
import ToolbarButton from "../ToolbarButton";
import { SearchResultsFormatType } from "../useSearchListingsPage";
import {
  createSearchResultsFormatSelector,
  createPaginationSelector,
} from "./utils";
import SortBy from "../SortBy";
import PageSize from "../PageSize";
import Pagination from "../Pagination";

export const MobileSearchToolbar = ({
  isDetailsOpen,
  currentFeature,
  searchResultsFormat,
  totalRecords,
  pageSize,
  currentPage,
  setSearchResultsFormat,
  setMapCenter,
  selectedPageListing,
  scrollToItemWithId,
  onSelectListing,
  listings,
  nextFeature,
  isLastFeature,
  onSearchParamsUpdated,
  isBatchSelectionActive = false,
  onBatchSelectionToggle,
  selectedSort,
  onFilterButtonClick,
}: {
  isDetailsOpen: boolean;
  currentFeature: string;
  searchResultsFormat: SearchResultsFormatType;
  totalRecords: number;
  pageSize: number;
  currentPage: number;
  setSearchResultsFormat: (format: SearchResultsFormatType) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setMapCenter: (center: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  selectedPageListing: any;
  scrollToItemWithId: (id: string) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSelectListing: (listing: any) => void;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  listings: any[];
  nextFeature: () => void;
  isLastFeature: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onSearchParamsUpdated: (params: any) => void;
  isBatchSelectionActive?: boolean;
  onBatchSelectionToggle?: () => void;
  selectedSort: string;
  onFilterButtonClick?: () => void;
}) => {
  const [isToolbarOpen, setIsToolbarOpen] = useState(false);

  return (
    <div
      className={`mobile-search-toolbar flex-wrap ${
        isDetailsOpen ? "" : "print:hidden"
      }`}
    >
      <div className="flex justify-between items-center">
        <div className="flex items-center gap-3">
          <div>
            {createSearchResultsFormatSelector({
              suppressMyLocation: true,
              isShowSearchResultsFormatTypeDiscoveryTooltip:
                currentFeature === "search-results-format-mobile",
              isShowMyLocationDiscoveryTooltip:
                currentFeature === "my-location-button-mobile",
            })({
              searchResultsFormat,
              setSearchResultsFormat,
              setMapCenter,
              selectedPageListing,
              scrollToItemWithId,
              onSelectListing,
              listings,
              currentFeature,
              nextFeature,
              isLastFeature,
            })}
          </div>
          <div>
            {createPaginationSelector({
              suppressPageSelector: true,
            })({
              totalRecords,
              pageSize,
              currentPage,
              onSearchParamsUpdated,
            })}
          </div>
        </div>
        <div className="flex gap-3">
          {onBatchSelectionToggle && (
            <ToolbarButton
              onClick={onBatchSelectionToggle}
              icon={<SquareCheck className="h-5 w-5" />}
              isActive={isBatchSelectionActive}
              tooltipContent="Select properties"
            />
          )}
          {onFilterButtonClick && (
            <ToolbarButton
              onClick={onFilterButtonClick}
              icon={<Filter className="w-4 h-4" />}
            />
          )}
          {/* Toggle filters panel */}
          <ToolbarButton
            onClick={() => setIsToolbarOpen(!isToolbarOpen)}
            icon={isToolbarOpen ? <FaAngleUp /> : <FaAngleDown />}
          />
        </div>
      </div>
      {isToolbarOpen && (
        <div className="mobile-toolbar-panel flex flex-wrap gap-3 mt-3">
          <SortBy
            value={selectedSort}
            onChange={(value: { sort: string; sort_dir: string }) => {
              onSearchParamsUpdated({
                sortField: value.sort,
                sortDir: value.sort_dir,
              });
            }}
          />
          <PageSize
            value={String(pageSize)}
            onChange={(value: string) => {
              onSearchParamsUpdated({
                pageSize: Number(value),
                currentPage: 1,
              });
            }}
          />
          <Pagination
            numRecords={totalRecords}
            pageSize={pageSize}
            suppressNavigationButtons
            currentPage={currentPage}
            onPageChange={(updatedPage: number) => {
              onSearchParamsUpdated({ currentPage: updatedPage });
            }}
          />
        </div>
      )}
    </div>
  );
};
